export default __webpack_public_path__ + "static/media/programguide-demo.31295bc8.png";